<template>
    <div class="w-full sm:w-6/12 md:w-4/12 lg:w-3/12 mt-2 sm:mt-6 px-5 sm:pl-4 sm:pr-4">
        <div @click.prevent="openListing" class="card card-product card-profile cursor-pointer text-center rounded shadow-none transition duration-200 border border-gray-300 hover:border-gray-500">
            <div v-if="listing.restricted" v-b-tooltip.hover title="This product has restrictions for buying." class="marker-icon marker-top-right absolute top-0 right-0">
                <!-- <fa-icon :icon="['fas', 'bolt']" /> -->
                <i class="far fa-bolt"></i>
            </div>
            <!-- <div v-else>
                <div v-if="isAdminUser" class="marker-icon marker-top-right absolute top-0 right-0">
                    <a @click.stop :href="listing.link" class="text-right text-xs" class2="absolute w-full right-0 bottom-0">
                        <fa-icon :icon="['fas', 'external-link-alt']" class="ml-4" style="margin-left: 1rem !important;" />
                        <i class="far fa-external-link-alt ml-4" style="margin-left: 1rem !important;"></i>
                    </a>
                </div>
            </div> -->

            <div v-cloak v-if="listing.stocked === true" class="marker marker-ribbon marker-success absolute t-10 left-0">
                In Stock
            </div>
            <div v-cloak v-if="listing.stocked === false" class="marker marker-ribbon marker-warning absolute t-10 left-0">
                Sold Out
            </div>
            <!-- <div v-cloak v-if="listing.stocked === null" class="marker marker-ribbon marker-dark absolute t-10 left-0">
                Unknown
            </div> -->

            <img v-if="listing.image_url" :data-src="listing.image_url" :alt="listing.name" class="lazyload card-img-top object-contain" />
            <div v-if="!listing.image_url" class="h-32"></div>

            <div class="card-body pb-2 cursor-pointer">
                <div>
                    <a v-if="listing.store.image_url && listing.store.slug !== 'amazon2'" @click.prevent="openStore" :href="listing.store.link">
                        <div class="avatar avatar-lg store-avatar">
                            <!-- <span :style="{ 'background-image': 'url(' + listing.store.image_url + ')' }" class="avatar-initial rounded-circle bg-white"></span> -->
                            <!-- <svg class="p-1 rounded-circle bg-white" viewBox="0 0 50 50" fill="none" width="50" height="50" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <image :href="listing.store.image_url" height="50" width="50" />
                            </svg> -->
                            <img :data-src="listing.store.image_url" :alt="listing.store.name" height="50" width="50" class="lazyload p-1 rounded-circle bg-white" />
                        </div>
                    </a>

                    <a v-if="!listing.store.image_url || listing.store.slug === 'amazon2'" @click.prevent="openStore" :href="listing.store.link">
                        <div class="avatar avatar-lg store-avatar">
                            <!-- <span :style="{ 'background-image': 'url(' + listing.store.image_url + ')' }" class="avatar-initial rounded-circle bg-white"></span> -->
                            <!-- <svg class="p-1 rounded-circle bg-white" viewBox="0 0 50 50" fill="none" width="50" height="50" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <image :href="listing.store.image_url" height="50" width="50" />
                            </svg> -->
                            <div class="block p-2 rounded-circle bg-white w-12 h-12 text-gray-700 mx-auto border">
                                <i class="far fa-store-alt fa-lg"></i>
                            </div>
                        </div>
                    </a>

                    <h5 class="sm:h-16 font-normal overflow-hidden text-truncate2 font-semibold mt-4 mb-0 text-base">
                        <a @click.prevent="openListing" :href="listingUrl">{{ listing.name }}</a>
                    </h5>

                    <h6 class="font-semibold mt-4 mb-5 text-gray-800 text-xl">
                        <span v-if="listing.stocked === true && listing.price !== null">
                            {{ currency(listing.price) }}
                        </span>
                        <span v-if="listing.stocked === true && listing.price === null">
                            See Site
                        </span>
                    </h6>

                    <div class="w-full">
                        <button v-cloak v-if="listing.stocked" type="button" class="btn btn-block btn-primary border-2 rounded-full font-semibold">
                            <i class="fad fa-shopping-cart fa-lg mr-1"></i>
                            Buy Now
                        </button>

                        <div v-cloak v-if="!listing.stocked">
                            <follow-listing-button :listing="listing" btn-class="btn-block" />
                        </div>

                        <div class="h-6 sm:h-8 mt-2 text-xs text-gray-600 relative">
                            <div class="absolute w-full" style="left: 0; bottom: 0;">
                                <div v-if="listing.stocked !== true && listing.stocked_at">
                                    Last stocked
                                    {{ dateTime(listing.stocked_at) }}
                                    <!-- <span v-else>&ndash;</span> -->
                                </div>

                                <div v-if="isAdminUser">
                                    <div v-if="listing.checked_at">
                                        Checked
                                        <span>{{ relative(listing.checked_at) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import numeral from "numeral";
import ListingMixin from '../../mixins/listing';
import StoreMixin from '../../mixins/store';

export default {
    mixins: [
        ListingMixin,
        StoreMixin
    ],

    props: ['listing'],

    data: () => ({}),

    created() {
        Bus.$on("productListingChecked", listing => {
            if (this.listing.id === listing.id) {
                // this.listing = listing;
                this.listing.price = listing.price;
                this.listing.stocked = listing.stocked;
                this.listing.checked_at = listing.checked_at;
                this.listing.stocked_at = listing.stocked_at;
                this.listing.updated_at = listing.updated_at;
            }
        });
    },

    mounted() {},

    computed: {
        store() {
            return this.listing.store;
        }
    },

    methods: {}
}
</script>

<style lang="scss">
.marker-warning.marker-ribbon {
    color: #333;
    background-color: #f7cb2e;
}

.card-profile {
    .card-img-top {
        object-fit: contain !important;
    }
}

.card-product {
    .card-body {
        border-bottom-width: 0;
        border-left-width: 0;
        border-right-width: 0;
    }
}
</style>
